import { createStyles, makeStyles, Button, Container, Grid, Typography, Paper } from '@material-ui/core';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import { ViewIcon } from '../../../../icons/ViewIcon';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { PrimaryButton } from '../../../common/PrimaryButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      padding: '1.5em',
      borderRadius: '8px',
    },
    paperContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '@media screen and (max-width: 950px)': {
        width: 'auto',
        paddingTop: '10px',
      },
    },
    errorIcon: {
      position: 'absolute',
      right: 'calc(100% + 18px)',
      '@media screen and (max-width: 1000px)': {
        display: 'none',
      },
    },
    downloadButton: {
      marginTop: '2em',
      '& svg': {
        position: 'relative',
        left: '-5px',
      },
    },
    viewButton: {
      marginTop: '0px',
      gap: '1px',
      '& svg': {
        position: 'relative',
        left: '-5px',
      },
      '@media screen and (max-width: 950px) and (min-width: 301px)': {
        display: 'flex',
      },
      '@media screen and (max-width: 351px)': {
        marginTop: '10px',
      },
    },
    gridContainer: {
      display: 'flex',
      '@media screen and (max-width: 950px)': {
        justifyContent: 'flex-start',
      },
      '@media screen and (max-width: 351px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    button: {
      '@media screen and (max-width: 950px)': {
        marginRight: '1,5em',
      },
    },
  })
);

interface CodecsTestFailedProps {
  openModal: () => void;
}

export function CodecsTestFailed({ openModal }: CodecsTestFailedProps) {
  const classes = useStyles();
  const { nextPane } = useAppStateContext();
  const { t } = useTranslation('', { keyPrefix: 'CODECS' });

  return (
    <>
      <Container>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item md={5}>
            <Typography variant="h1" gutterBottom style={{ position: 'relative' }}>
              <div className={classes.errorIcon}>
                <ErrorIcon />
              </div>
              {t('SOME_CODECS_NOT_SUPPORTED')}
            </Typography>

            <Typography variant="body1" gutterBottom>
              {t('SOME_CODECS_NOT_SUPPORTED_DESCRIPTION')}
            </Typography>

            <Grid
              item
              className={classes.gridContainer}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <PrimaryButton onClick={nextPane}>{t('SKIP_FOR_NOW')}</PrimaryButton>
              <Button
                color="primary"
                variant="outlined"
                disableRipple
                onClick={openModal}
                className={classes.viewButton}
              >
                <ViewIcon />
                {t('VIEW_DETAILED_INFORMATION')}
              </Button>
            </Grid>
          </Grid>

          <Grid item md={5} className={classes.paperContainer}>
            <Paper className={classes.paper}>
              <Typography variant="body1" gutterBottom>
                {t('SOME_CODECS_NOT_SUPPORTED_DESCRIPTION_2')}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
